// ----------------------------
// Created by Bulletproof Games
//            2022
//  www.bulletproofgames.co.uk
// ----------------------------
//
// GoldenBet Toggle Button ( based on LuckyBetToggle )

goldenBetToggleButton = {};

goldenBetToggleButton.create = function () {
  var button = new PIXI.Container();

  gameData.goldenBetBtn = button;

  button.goldenBetMessage = undefined;
  button._isPromotion = false;

  InputHelpers.addGenerics(button);
  button._flags.showGoldenBetActive = false;

  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);

  button._flags.platformEnabled = false;
  button._flags.platformVisible = false;

  button.canPlaceBet = false;

  button._potBonusActive = false;

  //////////////////////////////////////////
  button.canShow = function () {
    // Dont show in freespins
    return (
      !gameController.inFreeSpins &&
      !gameController.inFirelink &&
      this._flags.platformVisible &&
      !this._potBonusActive
    );
  };

  //////////////////////////////////////////
  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const goldenbetStakes =
      this.gameConfig.data.slotConfig.gameModes.LUCKYBET_BUY.coinSizes;
    const baseStake =
      resourceManager.getController("stakeController").BaseStake /
      gameData.numLines;
    const isCurrentBetAllowed = goldenbetStakes.includes(baseStake);
    button.canPlaceBet = isCurrentBetAllowed;

    var allow =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !this._isPromotion &&
      !button._sideMenuOpen &&
      this._flags.platformEnabled &&
      goldenbetStakes.length !== 0 &&
      isCurrentBetAllowed;

    var buttonToDim = button._flags.showGoldenBetActive
      ? this.button.buttonEnabled
      : this.button.buttonDisabled;

    buttonToDim.alpha = allow ? 1 : 0.5;

    return allow;
  };

  button.getCanPlaceBet = function () {
    return button.canPlaceBet;
  };

  //////////////////////////////////////////
  button.onConfig = function (config) {
    this.gameConfig = config;
    this._flags.platformEnabled = config.data.uiElements.btnUpstake.enabled;
    this._flags.platformVisible = config.data.uiElements.btnUpstake.visible;
  };

  //////////////////////////////////////////
  button.isAllowed = function () {
    return this._flags.platformEnabled;
  };

  //////////////////////////////////////////
  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe(
      "spinner:GameConfigEvent",
      button.onConfig.bind(button)
    );
    messageBus.subscribe(
      "common:PromotionStarted",
      button.promotionStarted.bind(button)
    );
    messageBus.subscribe(
      "common:PromotionEnded",
      button.promotionEnded.bind(button)
    );

    messageBus.subscribe(
      "8bof:PotBonusStartEvent",
      button.onPotBonusStartEvent.bind(button)
    );
    messageBus.subscribe(
      "8bof:PotBonusStartEventDead",
      button.onPotBonusStartEventDead.bind(button)
    );
    messageBus.subscribe(
      "game:sideMenuOpen",
      button.sideMenuOpenMsg.bind(button)
    );
    messageBus.subscribe(
      "game:sideMenuClosed",
      button.sideMenuClosedMsg.bind(button)
    );
  };

  ///////////////////////////////////////////////
  button.onLayoutComplete = function () {
    button.goldenBetMessage = resourceManager.get("goldenBetMessage");
    button.animParent = resourceManager.get("goldenBetToggleButton");

    button.glow = resourceManager.get("goldenBetToggleButton:glow");
    button.glow.alpha = 1;
    button.glowAnim = gsap
      .timeline({ repeat: -1, paused: true })
      .call(() => {
        button.glow.alpha = 1;
      })
      .to(button.glow, {
        duration: 2,
        alpha: 0.2,
      })
      .to(button.glow, {
        duration: 1,
        alpha: 1,
      });
    button.glow.visible = false;

    button.goldenBetMessage.alpha = 0;

    button.innerFadeTimer = undefined;
    button.outerFadeTimer = undefined;
  };

  //////////////////////////////////////////
  button.showButton = function () {
    if (this.canShow()) {
      if (!button._flags.showGoldenBetActive) {
        this.button.buttonDisabled.visible = true;
        this.button.buttonEnabled.visible = false;
      } else {
        this.button.buttonDisabled.visible = false;
        this.button.buttonEnabled.visible = true;
      }

      this.button.visible = true;
    } else {
      this.button.visible = false;

      this.button.buttonDisabled.visible = false;
      this.button.buttonEnabled.visible = false;
    }
  };

  //////////////////////////////////////////
  button.enterBuyABonus = function () {
    // on entering buy a bonus we must disable golden bet
    button._flags.showGoldenBetActive = false;
    button.cancelGoldenBet();
  };

  //////////////////////////////////////////
  button.cancelGoldenBet = function () {
    soundManager.play("buyBonusCancel");
    if (button.goldenBetMessage !== undefined) {
      button.goldenBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }

      button.glow.visible = false;
      button.glowAnim.pause();

      gameData.encoreEnabled = false;

      button.handleStakeChange();
    }
  };

  //////////////////////////////////////////
  button.handleStakeChange = function () {
    let goldenBetEnabled = gameData.encoreEnabled;
    let stakeController = resourceManager.getController("stakeController");

    stakeController.setStakeMultiplier(
      goldenBetEnabled ? gameData.goldenBetMultiplier : 1
    );
    gameController.onStakeChanged(
      stakeController.BaseStake *
        (goldenBetEnabled ? gameData.goldenBetMultiplier : 1)
    );
    stakeController.broadcastCurrentStake();
  };

  //////////////////////////////////////////
  button.setRecovery = function () {
    button.glowAnim.play(0);
    button.glow.visible = true;

    button._flags.showGoldenBetActive = true;
    gameData.encoreEnabled = true;

    button.handleStakeChange();
  };

  //////////////////////////////////////////

  button.promotionStarted = function () {
    this._isPromotion = true;
  };

  button.promotionEnded = function () {
    this._isPromotion = false;
  };

  button.onPotBonusStartEvent = function () {
    this._potBonusActive = true;
  };

  button.onPotBonusStartEventDead = function () {
    this._potBonusActive = false;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  button.onSpin = function () {
    if (button.goldenBetMessage !== undefined) {
      button.goldenBetMessage.alpha = 0.0;

      if (button.innerFadeTimer !== undefined) {
        timerManager.stop(button.innerFadeTimer);
      }

      if (button.outerFadeTimer !== undefined) {
        timerManager.stop(button.outerFadeTimer);
      }
    }
  };

  //////////////////////////////////////////
  button.onPressedCallback = function () {
    button._flags.showGoldenBetActive = !button._flags.showGoldenBetActive;

    if (button._flags.showGoldenBetActive) {
      if (button.goldenBetMessage !== undefined) {
        button.goldenBetMessage.alpha = 1.0;
        button.outerFadeTimer = timerManager.addTimer(
          4000,
          undefined,
          function () {
            button.innerFadeTimer = timerManager.addTimer(
              250,
              function (progress) {
                button.goldenBetMessage.alpha = 1 - progress;
              },
              function () {
                button.goldenBetMessage.alpha = 0.0;
              }
            );
          }
        );

        button.glow.visible = true;
        button.glowAnim.play(0);

        soundManager.play("goldenBetOn");

        gameData.encoreEnabled = true;
        button.handleStakeChange();
      }
    } else {
      button.cancelGoldenBet();
    }
  };

  return button;
};

goldenBetToggleButton.initialise = function (json, object) {
  object.setupResources();
};

goldenBetToggleButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "goldenBetToggleButton",
  goldenBetToggleButton.create,
  goldenBetToggleButton.initialise,
  goldenBetToggleButton.getFilesRequired
);
